module.exports = __webpack_public_path__ + "img/rhombuss-dispath-neg.ad0dda8f.png";